/**
 * Delete in the edit dialog (moved out of `NewConnectionPopup`, C3): main refuses to remove a record whose handle it
 * still holds, so a refused delete keeps the record and the dialog says why instead of a dead click (round 5).
 */
import { useState } from 'react';
import type { Connection } from '@/types/electron';

export const DELETE_REFUSED = "Couldn't delete this connection — it is still in use. Disconnect it and try again.";

export function useConnectionDelete(editConnection: Connection | undefined, onDelete: ((connectionId: string) => Promise<boolean>) | undefined) {
  const [deleting, setDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState<string | undefined>(undefined);

  const remove = async () => {
    if (!onDelete || !editConnection) return;
    setDeleting(true);
    setDeleteError(undefined);
    try {
      if (!(await onDelete(editConnection.id))) setDeleteError(DELETE_REFUSED);
    } finally {
      setDeleting(false);
    }
  };

  return { deleting, deleteError, onDelete: onDelete ? () => void remove() : undefined };
}
